import { Component } from "react";
import { withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import { setToast } from "./../../redux/actions/toast";
import { showModal } from "./../../redux/actions/modal";
import {
  getAggregators,
  getAggregatorDrilldown,
} from "./../../redux/actions/aggregators";

// Tabs
import FinancialStats from "./TabComponents/FinancialStats";
import AggregatorProfile from "./TabComponents/AggregatorProfile";
import Funders from "./TabComponents/Funders";
import Partners from "./TabComponents/Partners";
import AggregatorProfileSettings from "./TabComponents/AggregatorProfileSettings";
import Settings from "./TabComponents/Settings";

// Custom Components
import { HeaderWithButton } from "./../PageHeaders/PageHeaders";

// UI Components
import Filter from "./Filter/Filter";
import Tabs from "./../Tabs/Tabs";

// Styles
import "./ManageUsers.css";
import { getAggregatorStatistics } from "../../redux/actions/stats";
import AllWallet from "../Wallet/AllWallet";
import { getAggregatorProductTypes } from "../../custom-hooks/useAggregatorProductType";
import { appInsights } from "../../config/appInsights";

export class ManageUsers extends Component {
  //State
  state = {
    ecosystemData: {},
    ecosystemName: "",
    aggregatorProductTypes: null,
    activeTab: "finance",
    tabs: [
      {
        name: "Financial Statistics",
        id: "finance",
        icon: "fas fa-chart-line",
        identifier: "parentTab",
      },
      {
        name: "Aggregator Profile",
        id: "agg-profile",
        icon: "fas fa-building",
        identifier: "parentTab",
      },
      {
        name: "Aggregator Funders",
        id: "funders",
        icon: "fas fa-users",
        identifier: "parentTab",
      },
      {
        name: "Aggregator Borrowers",
        id: "borrowers",
        icon: "fas fa-users",
        identifier: "parentTab",
      },
      {
        name: "Profile Settings",
        id: "settings",
        icon: "fas fa-cog",
        identifier: "parentTab",
      },
      {
        name: "Wallet",
        id: "wallet",
        icon: "fas fa-credit-card",
        identifier: "parentTab",
      },
      {
        name: "Aggregator",
        id: "aggregator-setting",
        icon: "fas fa-building",
        identifier: "parentTab",
      },
    ],
  };

  // Methods
  modalHandler = (modalData) => {
    this.props.showModal(modalData);
  };

  handleGetAggregatorProductTypes = async (id) => {
    try {
      const response = await getAggregatorProductTypes(id);
      if (response?.data?.status === true) {
        this.setState({ aggregatorProductTypes: response });
      } else {
        this.props.showModal({
          modalIdentifier: "feedback",
          dataRecord: {
            type: "failure",
            message: response?.data?.message,
          },
        });
      }
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "ManageUsers.js",
        },
      });
      this.props.showModal({
        modalIdentifier: "feedback",
        dataRecord: {
          type: "failure",
          message: error?.response?.data?.message,
        },
      });
    }
  };

  onView = (item) => {
    this.props.getAggregatorStatistics(item.aggregator_id);
    this.handleGetAggregatorProductTypes(item.aggregator_id);
    let mode = item.mode;

    if (mode === "view") {
      this.setState({
        ecosystemData: item,
        ecosystemName: item.biz_name,
      });

      setTimeout(() => {
        document
          .querySelector(".ecosystem-selector")
          .classList.remove("speed-1x", "fadeInRight");
        document
          .querySelector(".ecosystem-selector")
          .classList.remove("fadeInRight");
        document
          .querySelector(".ecosystem-selector")
          .classList.add("speed-1x", "fadeOutLeft");

        setTimeout(() => {
          document.querySelector(".ecosystem-selector").classList.add("hidden");
          document
            .querySelector(".ecosystem-selector")
            .classList.remove("speed-1x", "fadeOutLeft");
          document.querySelector(".tabular-dataset").classList.remove("hidden");
          this.props.getAggregatorDrilldown(item.aggregator_id);
        }, 500);
      }, 500);
    } else if (mode === "close") {
      setTimeout(() => {
        document
          .querySelector(".tabular-dataset")
          .classList.remove("speed-1x", "fadeInRight");
        document
          .querySelector(".tabular-dataset")
          .classList.add("speed-1x", "fadeOutRight");

        setTimeout(() => {
          document.querySelector(".tabular-dataset").classList.add("hidden");
          document
            .querySelector(".tabular-dataset")
            .classList.remove("speed-1x", "fadeOutRight");
          document
            .querySelector(".ecosystem-selector")
            .classList.remove("hidden");
          document
            .querySelector(".ecosystem-selector")
            .classList.add("speed-1x", "fadeInLeft");
        }, 500);
      }, 500);
    }
  };

  closeView = (e) => {
    let mode = e.currentTarget.dataset.mode;

    if (mode === "close") {
      setTimeout(() => {
        document
          .querySelector(".tabular-dataset")
          .classList.remove("speed-1x", "fadeInRight");
        document
          .querySelector(".tabular-dataset")
          .classList.add("speed-1x", "fadeOutRight");

        setTimeout(() => {
          document.querySelector(".tabular-dataset").classList.add("hidden");
          // this.setState({
          //     activeTab: 'finance'
          // }, () =>{
          //     document.querySelector('.tabular-dataset').classList.remove('speed-1x', 'fadeOutRight');
          //     document.querySelector('.ecosystem-selector').classList.remove('hidden');
          //     document.querySelector('.ecosystem-selector').classList.add('speed-1x', 'fadeInLeft');
          // });
          document
            .querySelector(".tabular-dataset")
            .classList.remove("speed-1x", "fadeOutRight");
          document
            .querySelector(".ecosystem-selector")
            .classList.remove("hidden");
          document
            .querySelector(".ecosystem-selector")
            .classList.add("speed-1x", "fadeInLeft");
        }, 500);
      }, 500);
    }
  };

  toastHandler(type, message) {
    this.props.setToast(type, message);
  }

  toggleTabContent = (content) => {
    this.setState({
      activeTab: content,
    });
  };

  disableRecordHandler = (data) => {
    //e.preventDefault();
    let { userType, record } = data;
    document
      .querySelector(
        `[id='status'][data-user='${userType}'][data-id='${record}']`
      )
      .classList.toggle("status-active");
  };

  // Life Cycle Hooks
  componentDidMount() {
    if (!this.props.isAuthenticated) {
      this.props.history.push("/login");
    }

    this.props.getAggregators();

    appInsights.trackPageView({
      name: "Manage Aggregators - (ManageUsers.js)",
      isLoggedIn: true,
    });
  }

  //JSX Template
  render() {
    const {
      tabs,
      activeTab,
      ecosystemName,
      ecosystemData,
      aggregatorProductTypes,
    } = this.state;
    const { currentAggregator, allAggregators } = this.props;

    const {
      aggregatorDetails,
      partnerTableData: partnersTableData,
      funderTableData,
      loading,
      // error
    } = currentAggregator;

    return (
      <div className="ManageUsers">
        {/*Ecosystem Selector*/}
        <div className="mt-20 ecosystem-selector speed-1x fadeInRight">
          <div className="datatable-wrapper">
            <div className="table-view">
              <div className="mt-20">
                <Filter view={this.onView} dataRecords={allAggregators} />
              </div>
            </div>
          </div>
        </div>

        {/*Datatable for Selected Ecosystem */}
        <div className="tabular-dataset hidden ">
          <div className="datatable-wrapper">
            {/*Welcome Block*/}
            <HeaderWithButton
              headerText={`${ecosystemName} Ecosystem`}
              buttonText="Back to all Aggregators"
              onClick={(e) => this.closeView(e)}
            />

            {/*Tabs*/}
            <Tabs tabs={tabs} onContentToggle={this.toggleTabContent} />

            {/*Admin Views Controlled by Tabs*/}
            {(() => {
              switch (activeTab) {
                case "finance":
                  return <FinancialStats stats={this.props.aggregatorStats} />;
                case "agg-profile":
                  return (
                    <AggregatorProfile
                      aggregatorDetails={aggregatorDetails}
                      aggregator_id={ecosystemData.aggregator_id}
                      aggregatorProductTypes={aggregatorProductTypes}
                    />
                  );

                case "funders":
                  return (
                    <Funders
                      funderTableData={funderTableData}
                      loading={loading}
                      onModal={this.modalHandler}
                      showModal={this.props.showModal}
                      getAggregatorDrilldown={this.props.getAggregatorDrilldown}
                      aggregator_id={ecosystemData.aggregator_id}
                    />
                  );

                case "borrowers":
                  return (
                    <Partners
                      partnersTableData={partnersTableData}
                      loading={loading}
                      onModal={this.modalHandler}
                      showModal={this.props.showModal}
                      getAggregatorDrilldown={this.props.getAggregatorDrilldown}
                      aggregator_id={ecosystemData.aggregator_id}
                    />
                  );
                case "settings":
                  return (
                    <AggregatorProfileSettings
                      aggregator_id={ecosystemData.aggregator_id}
                    />
                  );
                case "wallet":
                  return (
                    <AllWallet aggregatorId={ecosystemData.aggregator_id} />
                  );
                case "aggregator-setting":
                  return (
                    <Settings
                      aggregatorData={ecosystemData}
                      onToast={this.props.setToast}
                    />
                  );

                default:
                  return null;
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { isAuthenticated, loggedInUser } = state.authReducer;
  const { currentAggregator, allAggregators } = state.aggregatorsReducer;
  const { aggregatorStats } = state.statsReducer;

  return {
    isAuthenticated,
    loggedInUser,
    currentAggregator,
    allAggregators,
    aggregatorStats,
  };
};

export default connect(mapStateToProps, {
  setToast,
  showModal,
  getAggregators,
  getAggregatorDrilldown,
  getAggregatorStatistics,
  showModal,
})(withRouter(ManageUsers));
